import { render } from "./usermanger.vue?vue&type=template&id=f9c66dd2&scoped=true&ts=true"
import script from "./usermanger.vue?vue&type=script&lang=ts"
export * from "./usermanger.vue?vue&type=script&lang=ts"

import "./usermanger.vue?vue&type=style&index=0&id=f9c66dd2&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9c66dd2"]])

export default __exports__